<div
  class="phone-input"
  [class.phone-input--invalid]="invalid"
  [class.phone-input--disabled]="disabled"
>
  <p-dropdown
    [options]="countries"
    [ngModel]="selectedCountry"
    [ngModelOptions]="{ standalone: true }"
    optionLabel="name"
    [filter]="true"
    filterBy="name,phoneCode,iso2"
    [disabled]="disabled"
    placeholder="Code"
    styleClass="form-control phone-input__country"
    (onChange)="onCountryChange($event.value)"
    (onBlur)="markAsTouched()"
  >
    <ng-template pTemplate="selectedItem" let-country>
      <div class="phone-input__selection" *ngIf="country">
        <app-country-flag [country]="country.iso2" [width]="18"></app-country-flag>
        <span>+{{ country.phoneCode }}</span>
      </div>
    </ng-template>
    <ng-template pTemplate="item" let-country>
      <div class="phone-input__option">
        <app-country-flag [country]="country.iso2" [width]="18"></app-country-flag>
        <span class="phone-input__country-name">{{ country.name }}</span>
        <span class="phone-input__dial-code">+{{ country.phoneCode }}</span>
      </div>
    </ng-template>
  </p-dropdown>

  <input
    pInputText
    [id]="inputId"
    type="tel"
    inputmode="numeric"
    autocomplete="tel-national"
    class="form-control phone-input__number"
    [value]="phoneNumber"
    [placeholder]="placeholder"
    [attr.maxlength]="maxPhoneNumberLength"
    [disabled]="disabled"
    (input)="onPhoneNumberInput($event)"
    (blur)="markAsTouched()"
  />
</div>